import { Navigate } from 'react-router-dom'

import { ROUTES } from '../../../constants/routes'
import { getVerifiedEmail } from '../../../utils/emailVerificationSession'
import { getPendingMembershipAgreements } from '../lib/membershipAgreements'

export default function SignUpFlowRoute({ element, stage }) {
  if (!getPendingMembershipAgreements()) {
    return <Navigate to={ROUTES.SIGN_UP} replace />
  }

  if (stage === 'details' && !getVerifiedEmail('SIGN_UP')) {
    return <Navigate to={ROUTES.SIGN_UP_EMAIL_VERIFICATION} replace />
  }

  return element
}
